module.exports = __webpack_public_path__ + "img/pivoine_coral_sunset.536ae4f6.jpg";